import { render, staticRenderFns } from "./IssueViewerConfiguration.vue?vue&type=template&id=cc34b168&"
import script from "./IssueViewerConfiguration.vue?vue&type=script&lang=ts&"
export * from "./IssueViewerConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports